import { c as _c } from "react/compiler-runtime";
import { FormLabel, Stack, TextField, Typography, FormControl, type SxProps } from '@mui/material';
import { useState } from 'react';
import type React from 'react';
import { HelpIcon } from '@/components/shared/helpIcon';
import type { FieldValidation } from './validation/fieldValidation';
import { InputErrorIcon } from './validation/inputErrorIcon';
export const FormTextField = t0 => {
  const $ = _c(55);
  const {
    size: t1,
    testId,
    title,
    helpText,
    alwaysShowHelp: t2,
    dataTestId,
    validation,
    placeholder,
    value,
    onChange,
    sx,
    disabled: t3,
    autoFocus: t4,
    multiline: t5,
    rows: t6,
    maxLength,
    type,
    inputProps,
    endAdornment,
    showValidationError: t7
  } = t0;
  const size = t1 === undefined ? "medium" : t1;
  const alwaysShowHelp = t2 === undefined ? false : t2;
  const disabled = t3 === undefined ? false : t3;
  const autoFocus = t4 === undefined ? false : t4;
  const multiline = t5 === undefined ? false : t5;
  const rows = t6 === undefined ? 1 : t6;
  const showValidationError = t7 === undefined ? false : t7;
  const [touched, setTouched] = useState(false);
  let t8;
  if ($[0] !== showValidationError || $[1] !== touched || $[2] !== validation || $[3] !== value) {
    t8 = (touched || showValidationError) && (validation ? !validation.validateInput(value) : false);
    $[0] = showValidationError;
    $[1] = touched;
    $[2] = validation;
    $[3] = value;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const hasError = t8;
  let t9;
  if ($[5] !== sx) {
    t9 = {
      width: "100%",
      ...sx
    };
    $[5] = sx;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== alwaysShowHelp || $[8] !== helpText || $[9] !== title) {
    t10 = title && <FormLabel><Stack direction="row" sx={{
        alignItems: "center",
        justifyContent: "space-between"
      }}><Typography variant="subtitle1">{title}</Typography>{helpText && <HelpIcon title={helpText} alwaysVisible={alwaysShowHelp} className="text-(--mui-palette-text-secondary)" />}</Stack></FormLabel>;
    $[7] = alwaysShowHelp;
    $[8] = helpText;
    $[9] = title;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setTouched(true);
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = hasError ? "4px" : "24px";
  let t13;
  if ($[12] !== t12) {
    t13 = {
      paddingRight: t12
    };
    $[12] = t12;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== multiline) {
    t14 = multiline && {
      "& .MuiOutlinedInput-input": {
        paddingLeft: "0px"
      }
    };
    $[14] = multiline;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== t13 || $[17] !== t14) {
    t15 = {
      "& .MuiInputBase-root": t13,
      ...t14
    };
    $[16] = t13;
    $[17] = t14;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== dataTestId) {
    t16 = dataTestId ? {
      "data-testid": dataTestId
    } : {};
    $[19] = dataTestId;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== maxLength) {
    t17 = maxLength !== undefined ? {
      maxLength
    } : {};
    $[21] = maxLength;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== inputProps || $[24] !== t16 || $[25] !== t17) {
    t18 = {
      ...inputProps,
      ...t16,
      ...t17
    };
    $[23] = inputProps;
    $[24] = t16;
    $[25] = t17;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== endAdornment || $[28] !== hasError || $[29] !== validation || $[30] !== value) {
    t19 = hasError ? <InputErrorIcon errorMessage={validation?.errorMessage(value)} /> : endAdornment;
    $[27] = endAdornment;
    $[28] = hasError;
    $[29] = validation;
    $[30] = value;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t19) {
    t20 = {
      endAdornment: t19
    };
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t18 || $[35] !== t20) {
    t21 = {
      htmlInput: t18,
      input: t20
    };
    $[34] = t18;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== autoFocus || $[38] !== disabled || $[39] !== hasError || $[40] !== multiline || $[41] !== onChange || $[42] !== placeholder || $[43] !== rows || $[44] !== size || $[45] !== t15 || $[46] !== t21 || $[47] !== testId || $[48] !== type || $[49] !== value) {
    t22 = <TextField multiline={multiline} rows={rows} size={size} autoFocus={autoFocus} data-testid={testId} onBlur={t11} error={hasError} sx={t15} slotProps={t21} type={type} placeholder={placeholder} disabled={disabled} value={value} onChange={onChange} />;
    $[37] = autoFocus;
    $[38] = disabled;
    $[39] = hasError;
    $[40] = multiline;
    $[41] = onChange;
    $[42] = placeholder;
    $[43] = rows;
    $[44] = size;
    $[45] = t15;
    $[46] = t21;
    $[47] = testId;
    $[48] = type;
    $[49] = value;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== t10 || $[52] !== t22 || $[53] !== t9) {
    t23 = <FormControl className="group/help" sx={t9}>{t10}{t22}</FormControl>;
    $[51] = t10;
    $[52] = t22;
    $[53] = t9;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  return t23;
};